// PageBG.jsx - Final working version
import React from 'react';

export default function PageBG({ src, children }) {
  return (
    <div 
      style={{ 
        minHeight: '100vh',
        width: '100%',
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        position: 'relative'
      }}
    >
      {/* Semi-transparent overlay for readability */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)', // 40% black overlay
          minHeight: '100vh'
        }}
      />
      
      {/* Your page content goes here */}
      <div style={{ position: 'relative' }}>
        {children}
      </div>
    </div>
  );
}
